module.exports = __webpack_public_path__ + "e427125c0b2bce33fb51bd75c3aa536b.svg";